import script from "./TopBrandPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopBrandPanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopBrandPanel.vue?vue&type=style&index=0&id=f0ea13bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0ea13bc"]])

export default __exports__